import React, { useState } from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { useTranslation } from 'react-i18next';
import { LeftCircle, RightCircle } from '../../../../assets/images/icons';

function Portfolio({ jobseeker, ref }) {
    const { t } = useTranslation();
    const [currentPage, setCurrentPage] = useState(0);
    const portfolios = jobseeker?.portfolio || []
    const portfoliosPerPage = 5;
    const startIndex = currentPage * portfoliosPerPage;
    const currentPortfolios = portfolios.slice(startIndex, startIndex + portfoliosPerPage);

    const handleNext = () => {
        if ((currentPage + 1) * portfoliosPerPage < portfolios.length) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };
    
    return (
        <div id="portfolio" ref={ref} className={styles.educationContainer} style={{ width: '100%', }}>
            <h2 className={styles.heading}>{t('portfolio.heading')}</h2>
            
            {portfolios.length > 0 ? (
                <>
                    <div className={styles.gridContainer}>
                        {/* First Column */}
                        <div className={styles.column}>
                            {currentPortfolios.slice(0, 2).map((item) => (
                                <div key={item.id} className={styles.portfolioContainer}>
                                    <img src={process.env.REACT_APP_UPLOADS_PATH + item.media} alt={`Portfolio ${item.id}`} className={styles.portfolioImage} />
                                </div>
                            ))}
                        </div>

                        {/* Second Column */}
                        {currentPortfolios[2] && (
                            <div className={styles.singleColumnContainer}>
                                <img src={process.env.REACT_APP_UPLOADS_PATH + currentPortfolios[2].media} alt={`Portfolio ${currentPortfolios[2].id}`} className={styles.portfolioImage} />
                            </div>
                        )}

                        {/* Third Column */}
                        <div className={styles.column}>
                            {currentPortfolios.slice(3, 5).map((item) => (
                                <div key={item.id} className={styles.portfolioContainer}>
                                    <img src={process.env.REACT_APP_UPLOADS_PATH + item.media} alt={`Portfolio ${item.id}`} className={styles.portfolioImage} />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Navigation Arrows */}
                    {portfolios?.length > 5 && (
                        <div className={styles.navigation}>
                            <button onClick={handlePrevious} disabled={currentPage === 0} className={styles.arrowButton}>
                                <img
                                    src={RightCircle}
                                    alt={`right icon`}
                                />
                            </button>
                            <button
                                onClick={handleNext}
                                disabled={(currentPage + 1) * portfoliosPerPage >= portfolios.length}
                                className={styles.arrowButton}
                            >
                                <img
                                    src={LeftCircle}
                                    alt={`left icon`}
                                />
                            </button>
                        </div>
                    )}
                </>
            ) : (
                <p className={styles.description} style={{ marginTop: '15px' }}>
                    {t('portfolio.no_portfolio')}
                </p>
            )}
        </div>
    );
}

export default Portfolio;
